import { RefObject } from 'react'
import { View } from 'react-native'

export const measureItemLeftPositionRelativeToAncestor = (
    ancestorRef: RefObject<View | null>,
    itemRef: RefObject<View | null>
): Promise<number> => {
    return new Promise((resolve, reject) => {
        if (!ancestorRef.current) return reject(new Error('containerRef.current is not available'))
        if (!itemRef.current) return reject(new Error('ref.current is not available'))

        itemRef.current.measureLayout(
            ancestorRef.current,
            (left) => resolve(left),
            () => reject(new Error('Category position is not available'))
        )
    })
}
